import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import Head from "@/components/Head/index.vue";
import Upload from "@/components/UpLoadFile/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  name: "Ranking",
  components: {
    Head: Head,
    Upload: Upload
  },
  setup: function setup() {
    var router = useRouter();
    var route = useRoute();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var activityId = route.query.activityId; // 提交按钮文字

    var submitText = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$btnText.$btn_submit; // 详情回显
    // 详情回显

    var detail = reactive({
      detailContent: {
        activity: {
          nums: ''
        }
      }
    });
    var isscore = ref(false);
    var list = reactive({
      rank: [{
        score: "",
        username: ""
      }]
    });

    function getRank() {
      return _getRank.apply(this, arguments);
    }

    function _getRank() {
      _getRank = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["rankingone"]({
                  paperId: route.query.historyId,
                  pageIndex: 1,
                  pageSize: 6,
                  code: 1
                });

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                isscore.value = data.some(function (item) {
                  return item.score !== undefined;
                });
                list.rank = data;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getRank.apply(this, arguments);
    }

    onMounted(function () {
      // 详情
      getRank();
    });
    return {
      submitText: submitText,
      list: list,
      detail: detail,
      isscore: isscore
    };
  }
});